import { Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import SoftBox from "../../../../../../../components/SoftBox";
import "./index.css";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { getOfferData } from "../../../../../../../config/Services";
import { OfferItem } from "../../../../../product/all-products/components/twoWaykeyboardPaymentPage/components/offerCheckModal/components/availableOffer";
import { getStoreCurrencySymbol } from "../../../../../../../utils/currency";

export const ProductDetailInfo = ({ datRows, priceInfo, packagingType, notFound }) => {
  const [priceData, setPriceData] = useState(null);
  const veg = `https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Veg_symbol.svg/120px-Veg_symbol.svg.png`;
  const nonveg = `https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Non_veg_symbol.svg/120px-Non_veg_symbol.svg.png`;

  useEffect(() => {
    const fetchData = async () => {
      if (priceInfo) {
        const promises = priceInfo?.multipleBatchCreations?.map(async (e) => {
          if (!e?.offerId) return e;
          const offerData = await getOfferData(e.offerId);
          return { ...e, offer: offerData?.data?.data };
        });
        const newOffer = await Promise.all(promises);
        setPriceData(newOffer);
      }
    };
    fetchData();
  }, [priceInfo]);

  return (
    <SoftBox>
      {!datRows || !priceInfo ? (
        <div className="prd-detail-container">
          <div className="prd-detail-box">
            {notFound && (
              <p className="no-data-found-prd">
                NO PRODUCT DATA FOUND FOR THIS LOCATION ID OR GTIN
              </p>
            )}
            <p>Scan or search with barcode to get the product details</p>
          </div>
        </div>
      ) : (
        <SoftBox mb={1}>
          <div className="prod_InfoTag">
            <Typography variant="h4" className="head-bundleStyle">
              {datRows?.name}({datRows?.gtin})
              <img
                style={{
                  display: datRows?.attributes?.food_type === "Not Applicable" ? "none" : "inline",
                  width: "1.2rem",
                  height: "1.2rem",
                  position: "absolute",
                  marginTop: "12px",
                  marginLeft: "0.5rem",
                }}
                src={datRows?.attributes?.food_type === "Vegetarian" ? veg : nonveg}
                alt=""
              />
            </Typography>
          </div>
          <SoftBox className="prod-mini-box">
            <Typography variant="h6" fontWeight="small" className="fruits-text">
              {datRows?.main_category}
              {datRows?.category_level_1 && <KeyboardArrowRightIcon className="left-icon-fruits" />}
              {datRows?.category_level_1}
              {datRows?.category_level_2 && <KeyboardArrowRightIcon />}
              {datRows?.category_level_2}
            </Typography>
          </SoftBox>
          <SoftBox className="price-prod-box-flex">
            <div style={{ marginTop: "5px" }}>
              <div className="bundle-cardStyle">
                <div className="bundle-cardContentStyle">
                  {(() => {
                    for (const key in datRows?.images) {
                      const image = datRows?.images[key];
                      if (image !== null) {
                        return (
                          <img key={key} src={image} alt="error" className="bundle-imageStyle" />
                        );
                      }
                    }
                    return (
                      <img
                        src={"https://i.imgur.com/dL4ScuP.png"}
                        alt="error"
                        className="bundle-imageStyle"
                      />
                    );
                  })()}
                </div>
              </div>
            </div>
            <div className="product-details-batches-box">
              <Typography variant="h4" className="head-bundleStyle">
                Available Batches
              </Typography>
              <div className="product-details-table-scroll"></div>
              <table className="product-details-table">
                <thead>
                  <tr>
                    <th>SI</th>
                    <th>Batch ID</th>
                    <th>Available Units</th>
                    <th>Mrp</th>
                    <th>Selling Price</th>
                    <th>Available Offers</th>
                  </tr>
                </thead>
                <tbody>
                  {priceData
                    ?.filter((batch) => batch.availableUnits !== 0)
                    ?.map((e, i) => (
                      <>
                        <tr>
                          <td>{i + 1}</td>
                          <td>{e?.batchId}</td>
                          <td>{e?.availableUnits}</td>
                          <td>{getStoreCurrencySymbol()}{e?.mrp}</td>
                          <td>{getStoreCurrencySymbol()}{e?.sellingPrice}</td>
                          <td>
                            {e?.offerId ? (
                              <OfferItem offer={priceData?.[i]?.offer?.data} />
                            ) : (
                              "No Offers Available"
                            )}
                          </td>
                        </tr>
                      </>
                    ))}
                </tbody>
              </table>
            </div>
          </SoftBox>
        </SoftBox>
      )}
    </SoftBox>
  );
};
